import { t } from 'i18next';

export default function labelPlaceholderWithOptional(label?: React.ReactNode, optional?: boolean): string {
  if (!label) return '';
  return `${label} ${optional ? t('label:optional_symbol') : ''}`;
}
